import React from 'react'
import { secondsToHms } from '../../redux/helpers'

export const CardAverageTime = ({ timeAverage }) => {


    return (
        <div className="flex flex-col justify-center items-center ">
            <p className="text-black font-semibold text-[45px]">{secondsToHms(timeAverage)}</p>
            <p className='text-[#3366FF] text-sm font-medium'>Horas y minutos</p>
        </div>
    )
}

export default CardAverageTime